// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import moment from 'moment-timezone'
import applicationIsWithinMaintenanceMode from './applicationIsWithinMaintenanceMode'
import { SYSTEM_MAINTENANCE_START_HOUR } from 'Routes/SystemMaintenanceCheck/constants'

/**
 * takes Moment instance, return milliseconds until maintenance window starts. <br />
 * throws if currentMoment is within Maintenance Window
 * @param {moment.Moment} currentMomentInEastern
 * @returns {number}
 */
const getTimeUntilMaintenanceStarts = currentMomentInEastern => {
  if (applicationIsWithinMaintenanceMode(currentMomentInEastern)) {
    throw new Error('Error: getTimeUntilMaintenanceStarts was called during the maintenance window')
  }

  const maintenanceWindowStart = moment(currentMomentInEastern)
    .add(1, 'day')
    .set('hour', SYSTEM_MAINTENANCE_START_HOUR)
    .set('minute', 0)
    .set('second', 0)
    .set('millisecond', 0)
    .valueOf()

  return maintenanceWindowStart - currentMomentInEastern.valueOf()
}

export default getTimeUntilMaintenanceStarts

